// The frame every start screen sits in: the city behind a dark veil, one card, progress dots.
import { el } from './dom.js';
import { t, setLang, lang, LANGS } from '../../shared/i18n.js';

export const STEPS = ['Age', 'You', 'Childhood', 'Arrival'];

// The language row: English, French, Pidgin. Changing it reloads the screen in that language.
export function languageRow() {
  const row = el('div.langs', { role: 'radiogroup', 'aria-label': t('Language') });
  for (const [code, name] of Object.entries(LANGS)) {
    row.append(el('button.lang', { type: 'button', role: 'radio', 'aria-checked': lang() === code ? 'true' : 'false', onclick: () => { if (lang() !== code) { setLang(code); location.reload(); } } }, name));
  }
  return row;
}

// frame({ step (1-based), title, lead, kicker, children, footer }) -> the #welcome node
export function frame(o) {
  const dots = el('ol.dots', { 'aria-label': t('Step {n} of {total}', { n: o.step, total: STEPS.length }) });
  STEPS.forEach((name, k) => dots.append(el('li', { class: k + 1 < o.step ? 'done' : k + 1 === o.step ? 'on' : undefined, title: t(name) }, el('span.sr-only', null, t(name)))));
  const card = el(
    'div.start-card',
    null,
    el('div.start-head', null, el('div.brand', null, 'Abakwa Mythlands'), o.step === 1 ? languageRow() : null, dots),
    o.kicker ? el('p.kicker', null, o.kicker) : null,
    el('h1', null, o.title),
    o.lead ? el('p.lead', null, o.lead) : null,
    o.children,
    o.footer ? el('div.start-foot', null, o.footer) : null
  );
  // the city behind the veil: set here, not in the stylesheet, so the bundler leaves the path alone
  const bg = el('div.bg', { 'aria-hidden': 'true', style: "background-image: linear-gradient(180deg, rgba(28, 26, 25, 0.45), rgba(28, 26, 25, 0.92)), url('/img/start-bg.jpg'), linear-gradient(160deg, #3a2418, #1c1a19)" });
  return el('div.start', { id: 'welcome' }, bg, card);
}
